import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { RootState } from '../../redux/store';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { AppBar, drawerClasses, IconButton, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { closeCartDrawer } from '../../redux/reducers/sideBarReducer';
import { OneColumnProductCard } from '../productCard/oneColumnProductCard';
import { CartInfo } from './cartInfo';
import { StickyCartBar } from '../appBars/cartBar/stickyCartBar';
import { useRouteNavigator } from '../../routes/useRouteNavigator';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import LoginRegister from './loginRegister';
import { CartServicesEmpty } from './cartServicesEmpty';

const StyledDrawer = styled(Drawer)({
  [`& .${drawerClasses.paper}`]: {
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '400px',
  },
});

export default function CartDrawer() {
  const dispatch = useAppDispatch();
  var routeNavigator = useRouteNavigator();
  const isOpened: boolean = useAppSelector((state: RootState) => state.sideBarState.isCartDrawerOpened);
  const shoppingCartItems = useAppSelector((state: RootState) => state.shoppingCartState.items);
  const isUserLoggedIn = useAppSelector((state: RootState) => state.authState.isLoggedIn);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setOpen(isOpened);
  }, [isOpened]);

  const handleDrawerClose = () => {
    dispatch(closeCartDrawer());
  };

  const goToCart = () => {
    handleDrawerClose();
    routeNavigator.goToCart();
  };

  return (
    <Box>
      <StyledDrawer
        anchor="right"
        variant="temporary"
        open={open}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <AppBar
          position="sticky"
          sx={{
            backgroundColor: 'appBar.background',
            color: 'appBar.color',
            pl: '20px',
            pr: '2px',
          }}
        >
          <Grid height="56px" container sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '20px' }} variant="button" display="block">
              {t('payment:cart')}
            </Typography>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon sx={{ color: 'white' }} />
            </IconButton>
          </Grid>
        </AppBar>
        {shoppingCartItems?.length > 0 ? (
          <Box sx={{ padding: '10px 15px' }}>
            <Stack spacing={2} sx={{ mb: '10px' }}>
              {shoppingCartItems.map((item) => (
                <OneColumnProductCard
                  item={item.serviceItem}
                  count={item.count}
                  isSmallFont
                  removable={item.removable}
                />
              ))}
            </Stack>
            <CartInfo hideHeader isSmallFont />
            {!isUserLoggedIn && (
              <Box sx={{ mb: '20px' }}>
                <LoginRegister isSmallFont disableHeader onRegisterClick={handleDrawerClose} />
              </Box>
            )}
            <StickyCartBar open={goToCart} isSmallFont />
          </Box>
        ) : (
          <CartServicesEmpty hideAddServiceButton />
        )}
      </StyledDrawer>
    </Box>
  );
}
